var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconAnimationMoveOut = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5 0.5C6.60457 0.5 7.5 1.39543 7.5 2.5V10.5L7.48926 10.7041C7.3938 11.6457 6.64565 12.3938 5.7041 12.4893L5.5 12.5H2L1.7959 12.4893C0.854346 12.3938 0.1062 11.6457 0.0107422 10.7041L0 10.5V2.5C1.28853e-07 1.39543 0.895431 0.5 2 0.5H5.5ZM2 1.5C1.48232 1.5 1.05621 1.89333 1.00488 2.39746L1 2.5V10.5C1 11.0523 1.44772 11.5 2 11.5H5.5C6.05228 11.5 6.5 11.0523 6.5 10.5V2.5C6.5 1.94772 6.05228 1.5 5.5 1.5H2Z",
    fill: "#908CA0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2041 0.510742C11.2128 0.613005 12 1.46435 12 2.5V10.5L11.9893 10.7041C11.8938 11.6457 11.1457 12.3938 10.2041 12.4893L10 12.5H9V11.5H10C10.5523 11.5 11 11.0523 11 10.5V2.5C11 1.98232 10.6067 1.55621 10.1025 1.50488L10 1.5H9V0.5H10L10.2041 0.510742Z",
    fill: "#908CA0"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconAnimationMoveOut);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-animation-move-out.b7fa7b368c58e01571171a339c19de05.svg";